<template>
  <div class="card mb-3">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold text-primary">General Info</h6>
    </div>
    <div class="card-body">
      <div class="form-group mb-2">
        <div class="row px-3">
          <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Kategori Pekerjaan <sup class="text-danger">*</sup></label>
          <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" name="education" id="form-education" v-model="data.helper_sub_category" >
            <option value="" selected="" disabled="">Pilih Kategori Pekerjaan</option>
            <option v-for="(data1,index) in helper_sub_category_arr" :key="index" :value="data1.id">{{ data1.name }}</option>
          </select>
        </div>
      </div>
      <div class="form-group mb-2">
        <div class="row px-3">
          <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Nominal Gaji <sup class="text-danger">*</sup></label>
          <input type="text" v-if="this.$route.query.id != null ? is_allow_edit : true" class="form-control col-lg-8" id="form-reference_by" @keyup="format_currency" v-model="data.requested_price">
          <p v-else class="m-0">Rp. {{ data.requested_price.toLocaleString() }}</p>
        </div>
      </div>
      <div class="form-group mb-2">
        <div class="row px-3">
          <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Tipe Gaji <sup class="text-danger">*</sup></label>
          <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" name="education" id="form-education" v-model="data.salary_type" >
            <option value="" selected="" disabled="">Pilih Tipe Gaji</option>
            <option value="monthly">Per Bulan</option>
            <option value="hourly">Per Jam</option>
          </select>
        </div>
      </div>
      <div class="form-group mb-2">
        <div class="row px-3">
          <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Menginap / Live In <sup class="text-danger">*</sup></label>
          <div v-show="this.$route.query.id != null ? is_allow_edit : true">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="could_live_in" v-model="data.could_live_in" id="could_live_in_yes" :value="1"/>
              <label class="form-check-label" for="could_live_in_yes">
                Ya
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="could_live_in" v-model="data.could_live_in" id="could_live_in_no" :value="0"/>
              <label class="form-check-label" for="could_live_in_no">
                Tidak
              </label>
            </div>
          </div>
          <div v-show="this.$route.query.id != null ? !is_allow_edit : false">
            <p class="m-0">{{ data.could_live_in == 1 ? 'Ya' : 'Tidak' }}</p>
          </div>
        </div>
      </div>
      <div class="form-group mb-2">
        <div class="row px-3">
          <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Takut Anjing <sup class="text-danger">*</sup></label>
          <div v-show="this.$route.query.id != null ? is_allow_edit : true">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="is_afraid_dog" v-model="data.is_afraid_dog" id="is_afraid_dog_yes" :value="1"/>
              <label class="form-check-label" for="is_afraid_dog_yes">
                Ya
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="is_afraid_dog" v-model="data.is_afraid_dog" id="is_afraid_dog_no" :value="0"/>
              <label class="form-check-label" for="is_afraid_dog_no">
                Tidak
              </label>
            </div>
          </div>
          <div v-show="this.$route.query.id != null ? !is_allow_edit : false">
            <p class="m-0">{{ data.is_afraid_dog == 1 ? 'Ya' : 'Tidak' }}</p>
          </div>
        </div>
      </div>
      <div class="form-group mb-2">
        <div class="row px-3">
          <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Pengalaman Kerja di Luar Negeri <sup class="text-danger">*</sup></label>
          <div v-show="this.$route.query.id != null ? is_allow_edit : true">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="have_work_abroad" v-model="data.have_work_abroad" id="have_work_abroad_yes" :value="1"/>
              <label class="form-check-label" for="have_work_abroad_yes">
                Ya
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="have_work_abroad" v-model="data.have_work_abroad" id="have_work_abroad_no" :value="0"/>
              <label class="form-check-label" for="have_work_abroad_no">
                Tidak
              </label>
            </div>
          </div>
          <div v-show="this.$route.query.id != null ? !is_allow_edit : false">
            <p class="m-0">{{ data.have_work_abroad == 1 ? 'Ya' : 'Tidak' }}</p>
          </div>
        </div>
      </div>
      <div class="form-group mb-2">
        <div class="row px-3">
          <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Mengerti Bahasa Inggris <sup class="text-danger">*</sup></label>
          <div v-show="this.$route.query.id != null ? is_allow_edit : true">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="is_understood_english" v-model="data.is_understood_english" id="is_understood_english_yes" :value="1"/>
              <label class="form-check-label" for="is_understood_english_yes">
                Ya
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="is_understood_english" v-model="data.is_understood_english" id="is_understood_english_no" :value="0"/>
              <label class="form-check-label" for="is_understood_english_no">
                Tidak
              </label>
            </div>
          </div>
          <div v-show="this.$route.query.id != null ? !is_allow_edit : false">
            <p class="m-0">{{ data.is_understood_english == 1 ? 'Ya' : 'Tidak' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data','is_allow_edit',],
  data(){
    return{
      helper_sub_category_arr: [],
    }
  },
  created(){
    this.get_helper_category_data()
  },
  methods:{
    format_currency(e){
      var price = parseFloat(this.data.requested_price.replace(/\./g,'').replace(/,/g,''))
      this.data.requested_price = price.toLocaleString()
    },
    async get_helper_category_data(){
      var response = await axios.get(base_url+'/helper-sub-category/all')

      var response_data = response.data

      if(response_data.status == "success"){
        this.helper_sub_category_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
  }
}
</script>
